import React from 'react'
import { isRouteAllowed, reverse } from 'src/routes/config'
import MainMenuItem from 'src/components/Menu/MainMenuItem'
import isFeatureEnabled, { FEATURES } from 'src/utils/isFeatureEnabled'
import useTranslations from 'src/hooks/useTranslations'
import getEnvVariableValue, { VARIABLES } from 'src/utils/getEnvVariableValue'
import useUserData from 'src/hooks/useUserData'
import { faUserHeadset } from '@fortawesome/pro-regular-svg-icons/faUserHeadset'
import { faUserHeadset as faUserHeadsetSolid } from '@fortawesome/pro-solid-svg-icons/faUserHeadset'

const baseUrlHorizon = getEnvVariableValue(VARIABLES.OLD_HORIZON_BASE_URL)

export default function SupportCenterMenu({
    parentIsCollapsed,
    isOpen,
    onClick,
}) {
    const { t } = useTranslations('MainMenu', 'MainMenu')
    const userData = useUserData()

    return (
        <MainMenuItem
            icon={faUserHeadset}
            iconActive={faUserHeadsetSolid}
            title={t('Support center')}
            parentIsCollapsed={parentIsCollapsed}
            isOpen={isOpen}
            onClick={onClick}
        >
            {isRouteAllowed(userData, 'support-center') && (
                <MainMenuItem
                    title={t('Overview')}
                    to={
                        isFeatureEnabled(FEATURES.COLLABORATION_MENU_OPTION)
                            ? reverse('support-center')
                            : {
                                  pathname: `${baseUrlHorizon}/support-center`,
                              }
                    }
                    externalLink={
                        !isFeatureEnabled(FEATURES.COLLABORATION_MENU_OPTION)
                    }
                />
            )}
            {isRouteAllowed(userData, 'tickets') && (
                <MainMenuItem
                    title={t('Tickets')}
                    to={reverse('analyst-tickets')}
                />
            )}
            {isRouteAllowed(userData, 'changes') && (
                <MainMenuItem title={t('Changes')} to={reverse('changes')} />
            )}
            {isRouteAllowed(userData, 'governance-roles') && (
                <MainMenuItem
                    title={t('Governance roles')}
                    to={reverse('governance-roles')}
                />
            )}
        </MainMenuItem>
    )
}
